import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const VrfyEmail = styled.div`
  height: 420px;
  display: flex;
  flex-direction: column;
`;
export const VrfyEmailHdr = styled.div`
  display: flex;
  margin-bottom: 30px;
  @media ${device.mobileS} {
    margin-bottom: 10px;
    justify-content: flex-end;
  }
`;
export const Heading = styled.h3`
  font-size: 32px;
  line-height: 40px;
  font-weight: 900;
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  span {
    width: 28px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
  }
  img {
    width: 28px;
  }
  @media ${device.mobileS} {
    font-size: 22px;
    line-height: 28px;
    span {
      display: none;
    }
  }
`;
export const SubHeading = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: #000;
  margin-bottom: 8px;
  span {
    font-weight: 700;
  }
  @media ${device.mobileS} {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  margin-top: 50px;
  @media ${device.mobileS} {
    margin-top: 20px;
  }
`;

export const FooterText = styled.p`
  font-size: 14px;
  line-height: 18px;
  margin-top: 96px;
  a {
    text-decoration: underline;
  }
`;

export const ErrorMsg = styled.p`
  color: #eb2026;
  font-size: 16px;
  font-weight: 400;
  margin-top: 22px;
`;

export const Edit = styled.span`
  font-size: 16px;
  color: #0091ff;
  font-weight: 400;
  margin-top: 15px;
  cursor: pointer;
`;
